import { lazy } from "react";
import { ScreenType } from "./Login";


const Login = lazy(() => import("./Login"));
const PageNotFound = lazy(() => import("./404"));
const Unauthorized = lazy(() => import("./401"));
const OPT = lazy(() => import("./OPT"));
const Lobby = lazy(() => import("./Lobby"));
const MobileLobby = lazy(() => import("./MobileLobby"));
const Messages = lazy(() => import("./Messages"));
const Docs = lazy(() => import("./Docs"));
const MobileMessage = lazy(() => import("./MobileMessage"));
const MobileDoc = lazy(() => import("./MobileDoc"));
const Accounts = lazy(() => import("./Accounts"));
const Contacts = lazy(() => import("./Contacts"));
const Projects = lazy(() => import("./Projects"));
const Tenants = lazy(() => import("./Tenants"));
const MobileContacts = lazy(() => import("./MobileContacts"));
const MobileRepairPage = lazy(() => import("./MobileRepairPage"));
const NewApply = lazy(() => import("../components/Applies/NewApply"));
const LicenseUpdateForm = lazy(() => import("./LicenseUpdateForm"));
const AdminPassword = lazy(() => import("./AdminPassword"));

export {
  Login,
  PageNotFound,
  Unauthorized,
  OPT,
  Lobby,
  MobileLobby,
  Messages,
  ScreenType,
  Docs,
  Accounts,
  Contacts,
  Projects,
  Tenants,
  MobileDoc,
  MobileMessage,
  MobileContacts,
  MobileRepairPage,
  NewApply,
  LicenseUpdateForm,
  AdminPassword
};
